import PhotosImageViewer from './PhotosImageViewer';

export default PhotosImageViewer;
